import styled from 'styled-components';
import { Avatar, Text } from 'components';
import { REFERRAL_COLORS } from './theme';

const Bar = styled.div`
  display: flex;
  align-items: center;
  justify-content: space-between;
  padding: 16px;
`;

const TeamRow = styled.div`
  display: flex;
  align-items: center;
  gap: 8px;
  min-width: 0;
  padding: 0 16px 12px;
`;

const TeamName = styled.div`
  min-width: 0;
  overflow: hidden;
  white-space: nowrap;
  text-overflow: ellipsis;
`;

const LivePill = styled.div`
  border: 1px solid ${REFERRAL_COLORS.white};
  border-radius: 999px;
  padding: 4px 12px;
`;

// Brand stays top-left as before; whose challenge this is (previously not
// shown anywhere on this screen) gets its own row underneath.
const ReferralHeader = ({ team }) => (
  <>
    <Bar>
      <Text b1 bold col={REFERRAL_COLORS.white}>
        Playaz4Playaz
      </Text>
      <LivePill>
        <Text c1 bold col={REFERRAL_COLORS.white}>
          LIVE SPREE
        </Text>
      </LivePill>
    </Bar>
    <TeamRow>
      <Avatar user={team} small />
      <TeamName>
        <Text b1 bold col={REFERRAL_COLORS.white}>
          {team?.name || team?.username}
        </Text>
      </TeamName>
    </TeamRow>
  </>
);

export default ReferralHeader;
